<template>
  <div>
    <h3>Administrationsveje</h3>
    <div
      class="row route-status"
      v-if="statuses.length"
    >
      <div class="col-xs-4 col-xs-offset-4">
        <strong>Konkurrence</strong>
      </div>
      <div class="col-xs-4">
        <strong>Træning</strong>
      </div>
    </div>
    <div
      class="row route-status"
      v-for="route in statuses"
      :key="route.id"
    >
      <div class="col-xs-4">
        {{ getSingleRouteOfAdministration(route.routeOfAdministrationID).name }}
      </div>
      <div class="col-xs-4">
        <DisplayIcon
          :id="route.statusCompetition"
          :extended="true"
        />
      </div>
      <div
        class="
          col-xs-4"
      >
        <DisplayIcon
          :id="route.statusTraining"
          :extended="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DisplayIcon from './DisplayIcon.vue';

export default {
    name: 'RouteOfAdministrationStatuses',
    components: { DisplayIcon },
    props: {
        statuses: { type: Array, required: true },
    },
    computed: {
        ...mapGetters({
            getSingleRouteOfAdministration: 'routeofadministration/getSingleRouteOfAdministration',
        }),
    },
};
</script>

<style lang="scss" scoped>
.route-status {
    margin-bottom: 5px;
}
</style>
